export default __webpack_public_path__ + "static/media/addStudent.64b859f7.svg";